export default __webpack_public_path__ + "static/media/Dauten_logo.e7f3aac0.png";